export default "__VITE_ASSET__1fb428bf__"